import * as React from 'react';
import { FlexRowCenter } from '../Flexbox/Flexbox';
import styled from 'styled-components';

export interface Props {
  color?: string;
  width?: string;
  height?: string;
  image?: string;
  imageSize?: string;
  clickable?: boolean;
  disabled?: boolean;
  className?: any;
  click?: () => void;

  balloonText?: string;
  balloonPos?: string;

  hoverColor?: string;
  imgStyle?: React.CSSProperties;
  imageHover?: string;
}

export class ButtonCircle extends React.Component<Props> {
  render() {
    return (
      <ButtonCircleComponent
        image={this.props.image}
        imageHover={this.props.imageHover}
        imageSize={this.props.imageSize}
        hoverColor={this.props.hoverColor}
        style={{
          backgroundColor: this.props.color || '',
          outline: 'none',
        }}
        className={[
          this.props.clickable === true ? 'clickable' : '',
          this.props.disabled === true ? 'disabled' : '',
          this.props.className ? this.props.className : '',
        ].join(' ')}
        onClick={this.handleClick}
        data-balloon={this.props.balloonText}
        data-balloon-pos={this.props.balloonPos}
      >
        {this.props.children && (
          <React.Fragment>{this.props.children}</React.Fragment>
        )}
      </ButtonCircleComponent>
    );
  }

  private handleClick = () => {
    if (this.props.disabled === true) {
      return;
    }
    if (this.props.click) {
      this.props.click();
    }
  };
}

const ButtonCircleComponent: any = styled(FlexRowCenter)`
  width: 60px;
  height: 60px;
  border-radius: 180px;
  transition: background-color 0.2s;
  transition: opacity 0.2s, background-color 0.2s;
  background-image: url(${(props: any) => props.image});
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: ${(props: any) => props.imageSize || '50%'};
  &.clickable {
    cursor: pointer;
    &:hover {
      ${(props: any) => {
        if (props.hoverColor) {
          return `
            background-color: ${props.hoverColor} !important;
            opacity: 1;
          `;
        }

        return `opacity: 0.8`;
      }};
      background-image: url(${(props: any) => props.imageHover || props.image});
    }
    &:active {
      opacity: 0.6;
    }
  }

  &.disabled {
    opacity: 0.4;
    &:hover {
      opacity: 0.4;
    }
    &:active {
      opacity: 0.4;
    }
  }
`;
